/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url */
import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange, translationMap }) => {
  const handlePrevious = (e) => {
    e.preventDefault();
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];

    // Always show the first page
    pages.push(
      <li key={1} className="page-item">
                <a
          className={`page-link ${currentPage === 1 ? "active" : ""}`}
          href="javascript:void(0);"
          onClick={(e) => { e.preventDefault(); onPageChange(1); }}>

                    1
                </a>
            </li>
    );

    // Show ellipsis if current page is far from the first page
    if (currentPage > 3) {
      pages.push(
        <li key="start-ellipsis" className="page-item">
                    <span className="page-link">...</span>
                </li>
      );
    }

    // Show the current page and up to one page before and after it
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
      pages.push(
        <li key={i} className="page-item">
                    <a
            className={`page-link ${i === currentPage ? "active" : ""}`}
            href="javascript:void(0);"
            onClick={(e) => { e.preventDefault(); onPageChange(i); }}>

                        {i}
                    </a>
                </li>
      );
    }

    // Show ellipsis if current page is far from the last page
    if (currentPage < totalPages - 2) {
      pages.push(
        <li key="end-ellipsis" className="page-item">
                    <span className="page-link">...</span>
                </li>
      );
    }

    // Always show the last page if more than one page
    if (totalPages > 1) {
      pages.push(
        <li key={totalPages} className="page-item">
                    <a
            className={`page-link ${currentPage === totalPages ? "active" : ""}`}
            href="javascript:void(0);"
            onClick={(e) => { e.preventDefault(); onPageChange(totalPages); }}>

                        {totalPages}
                    </a>
                </li>
      );
    }

    return pages;
  };

  return (
    <>
            {/* Desktop View */}
            <div className="pagination_main_wrapper d-none d-md-block">
                <nav aria-label="Page navigation" className="Pagination_custom_box">
                    <div className="Pre_box">
                        <button onClick={handlePrevious} disabled={currentPage === 1}>
                            <i className="material-symbols-outlined">arrow_back_ios</i> {translationMap?.previous}
                        </button>
                    </div>
                    <ul className="pagination">
                        {renderPageNumbers()}
                    </ul>
                    <div className="next_box">
                        <button onClick={handleNext} disabled={currentPage === totalPages}>
                            {translationMap?.next} <i className="material-symbols-outlined">arrow_forward_ios</i>
                        </button>
                    </div>
                </nav>
            </div>

            {/* Mobile View */}
            <div className="paginationMainWrapper d-block d-md-none mb-10">
                <nav aria-label="Page navigation" className="Pagination_custom_box">
                    <div className="Pre_box">
                        <a href="javascript:void(0);" onClick={handlePrevious} className={currentPage === 1 ? "disabled" : ""} role="button">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                  d="M14.6066 0L15.8333 1.22667L7.05998 10L15.8333 18.7733L14.6066 20L5.21998 10.6133L4.63331 10L5.21998 9.38667L14.6066 0Z"
                  fill="#003366">
                </path>
                            </svg>
                        </a>
                    </div>
                    <p>
                        {translationMap?.page} <span className="pageNumber">{currentPage}</span> {translationMap?.of} <span className="totalPage">{totalPages}</span>
                    </p>
                    <div className="next_box">
                        <a href="javascript:void(0);" onClick={handleNext} className={currentPage === totalPages ? "disabled" : ""} role="button">
                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#002F70"></rect>
                                <path
                  d="M19.3933 14L18.1666 15.2267L26.94 24L18.1666 32.7733L19.3933 34L28.78 24.6133L29.3666 24L28.78 23.3867L19.3933 14Z"
                  fill="#003366">
                </path>
                            </svg>
                        </a>
                    </div>
                </nav>
            </div>
        </>);

};

export default Pagination;